import React from 'react';
import Lot from "./Lot";
import useZibi from "../zibi/UseZibi";


function BusyIndicator() {
    const [busyIndicator] = useZibi('busyIndicator');

    return (
        (busyIndicator > 0) && <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: '100vh',
            height: '100vh',
            width: '100vw',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 100000
        }}>
            <div style={{width: 600}}><Lot>loader</Lot></div>
        </div>
    );
}

export default BusyIndicator;